export default function TooltipWrapper({ label, children }) {
  return (
    <div className="relative group cursor-pointer">
      {children}
      <span className="absolute -top-7 left-1/2 -translate-x-1/2 whitespace-nowrap bg-neutral-800 text-white text-xs py-1 px-2 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200">
        {label}
      </span>
    </div>
  );
}
